import { setDetailsData, setOemData } from "../../../slices/oem/oemSlice";
import rootReducer from "../../../store";
import {
  editModal,
  openModal,
  RenderPage,
  resetFormState,
  updateRendererFormState,
} from "../../../slices/common/reducer";
import { showToast } from "../../../common/Toaster/Toaster";
import api from "../../../Utils/interface";

export const getOemListing = (entity_type) => {
  let fd = new FormData();

  fd.append("entity_type", entity_type);
  api
    .post(`/agsp/getEntityList`, fd, {})
    .then((res) => {
      rootReducer.dispatch(setOemData(res.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

// export const createOem = async (entity, organizationid, entitytype) => {
//   let fd = new FormData();
//   fd.append("entity", JSON.stringify({ ...entity, organizationid }));
//   fd.append("entitytype", entitytype);
//   const fileData = {};

//   // Collect file data even if the key is in the excluded list (like logo_media_id)
//   Object.keys(entity).forEach((key) => {
//     if (
//       entity[key] instanceof File ||
//       entity[key]?.type === "file"
//     ) {
//       // Handle file type (both when it's a File object or existing file information)
//       fileData[key] = entity[key];
//     }
//   });

//   // Append file data separately (either as File object or existing file reference)
//   Object.keys(fileData).forEach((key) => {
//     const file = fileData[key];

//     if (file instanceof File) {
//       // If it's a new File object, append it directly
//       fd.append(key, file, file.name);
//     } else if (file?.type === "file") {
//       // If it's an existing file, append the existing file data (e.g., base64 or other format)
//       fd.append(key, file.data);
//     }
//   });

//   try {
//     const response = await api.post(`/agsp/create`, fd);

//     rootReducer.dispatch(RenderPage());
//     rootReducer.dispatch(resetFormState());
//     rootReducer.dispatch(openModal(false));

//     showToast("OEM added successfully", "success");
//   } catch (error) {
//     // Handle error
//     showToast(
//       error?.response?.data?.error_message || "Unknown error occurred",
//       "error"
//     );
//   }
// };

export const createOem = async (entity, organizationid, entitytype) => {
  let fd = new FormData();

  // Create a new object excluding file-related fields
  const entityWithoutFiles = { ...entity };
  const fileData = {};

  // Separate file data and remove file-related keys from entity
  Object.keys(entity).forEach((key) => {
    if (entity[key] instanceof File || entity[key]?.type === "file") {
      fileData[key] = entity[key]; // Collect file data separately
      delete entityWithoutFiles[key]; // Remove the file key from the entity
    }
  });

  // Append the entity object without file data
  fd.append(
    "entity",
    JSON.stringify({ ...entityWithoutFiles, organizationid })
  );
  fd.append("entitytype", entitytype);

  // Append file data separately
  Object.keys(fileData).forEach((key) => {
    const file = fileData[key];

    if (file instanceof File) {
      fd.append(key, file, file.name); // Append the new File object
    } else if (file?.type === "file") {
      fd.append(key, file.data); // Append existing file data (e.g., base64 or other format)
    }
  });

  try {
    const response = await api.post(`/agsp/create`, fd);

    rootReducer.dispatch(RenderPage());
    rootReducer.dispatch(resetFormState());
    rootReducer.dispatch(openModal(false));

    showToast("OEM added successfully", "success");
  } catch (error) {
    // Handle error
    showToast(
      error?.response?.data?.error_message || "Unknown error occurred",
      "error"
    );
  }
};

export let updateOem = async (entity, entityid, entityType, navigator) => {
  const entityWithoutFiles = { ...entity }; // Make a copy of entity excluding the file data

  // Remove file keys from entityWithoutFiles to exclude them from being part of the entity
  Object.keys(entityWithoutFiles).forEach((key) => {
    if (entity[key] instanceof File || entity[key]?.type === "file") {
      delete entityWithoutFiles[key]; // Remove file-related keys from the entity object
    }
  });

  const updatedEntity = {
    ...entityWithoutFiles,
    entityid: entityid,
    entitytype: entityType,
  };

  let fd = new FormData();
  fd.append("entity", JSON.stringify(updatedEntity)); // Append the updated entity without file data
  fd.append("entityid", entityid);
  fd.append("entitytype", entityType);

  const fileData = {};

  // Collect file data separately, excluding it from the main entity object
  Object.keys(entity).forEach((key) => {
    if (entity[key] instanceof File || entity[key]?.type === "file") {
      fileData[key] = entity[key]; // Collect file data
    }
  });

  // Append file data to FormData (separately from the entity)
  Object.keys(fileData).forEach((key) => {
    const file = fileData[key];

    if (file instanceof File) {
      // If it's a new File object, append it directly
      fd.append(key, file, file.name);
    } else if (file?.type === "file") {
      // If it's an existing file, append the existing file data (e.g., base64 or other format)
      fd.append(key, file.data);
    }
  });

  // Send the update request
  try {
    const response = await api.post(`/agsp/update`, fd, {});
    rootReducer.dispatch(RenderPage());
    rootReducer.dispatch(resetFormState());
    rootReducer.dispatch(editModal(false));
    rootReducer.dispatch(openModal(false));
    showToast("OEM Updated Successfully!", "success");
    navigator("/prod/oem");
  } catch (error) {
    showToast(
      error?.response?.data?.error_message || "Error occurred during update",
      "error"
    );
  }
};

export const getOemData = (entity_id, entity_type) => {
  let fd = new FormData();

  fd.append("entityid", entity_id);
  fd.append("entitytype", entity_type);
  api
    .post(`/entity/read`, fd, {})
    .then((res) => {
      if (res) {
        rootReducer.dispatch(setDetailsData(res.data));
        rootReducer.dispatch(updateRendererFormState(res.data));
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
